//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/scroll_view'

//#endregion

import { SERVICE_NAME as SYSTEM_SERVICE_NAME, SystemService, $SCOPE_SERVICE_NAME } from '../../../services/system'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'
import { METER_SERVICE_NAME, MeterService } from '../../../services/meter'

//#region Asset Imports

import './connected-object.scss'
import * as TEMPLATE from './connected-object.tpl.html'

//#endregion

export interface ConnectedObject {
    connectedObjectId: number
    connectedObjectName: string
    connectedObjectVisibility: boolean
    connectedObjectTitle: string
    connectedObjectMethod: string
    connectedObjectAllowLink?: boolean
}

export class ConnectedObjectDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        connection: '=',
        actions: '='
    }
    controller = [$SCOPE_SERVICE_NAME, SYSTEM_SERVICE_NAME, DEVICE_SERVICE_NAME, METER_SERVICE_NAME, (
        $scope: ng.IScope,
        systemService: SystemService,
        deviceService: DeviceService,
        meterService: MeterService
    ) => {
        $scope['deviceDetails'] = (id, title) => {
            systemService.openDetails(deviceService.getDetailsOptions(id))
        }
        $scope['meterDetails'] = (id, title) => {
            systemService.openDetails(meterService.getDetailsOptions(id))            
        }
    }]
    template = TEMPLATE
}